import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    formControlAutoComplete: {
        minWidth: "100%",
        margin: "10px"
    },
    formControl: {
        minWidth: "100%",
        margin: "10px",
    },
    input: {
        padding: "5px",
    },
    closePaper:{
        textAlign: "end",
        height: "24px",
        padding: "5px"
    },
    zeitraumSelect: {
        textAlignLast:"left",
        minWidth: "80%",
        padding: "10px",
        marginInline: "auto",
    },
    tableHeadlineAutocomplete: {
        backgroundColor: theme.palette.info.light,
        color: "white",
        alignSelf: "center",
        paddingTop: "10px"
    },
    centerTypographyRoot: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center"
    },
    select: {
        color: "white",
    },
    label:{color: "white"},
    icon: { color: "white" },
    selectBorder: {
        textAlignLast: "left",
        display: "block",
        color: "white !important",
        label: { color: "white !important" },
        "&:before": {
            color: "white !important",
            borderColor: "white !important"
        },
        "&:hover": {
            color: "white !important",
            borderColor: "white !important"
        },
        "&:after": {
            color: "white !important",
            borderColor: "white !important",
        },
        "&:active": {
            color: "white !important",
            borderColor: "white !important"
        },
        "&:focus": {
            color: "white !important",
            borderColor: "white !important"
        },
        "&:target": {
            color: "white !important",
            borderColor: "white !important"
        },
        "& .MuiIconButton-label": {
            color: "white !important",
            borderColor: "white !important"
        }
    },
    highlightCell: { 
        color: theme.palette.primary.main,
        backgroundColor: "rgb(250, 250, 235)" 
    },
    tableHeadlineSubHighLight:{
        color: theme.palette.primary.main,
        backgroundColor:"white",
    },

    paddingPaper:{
        paddingBottom: theme.spacing(2),
        minHeight:"100%",
        height:"100%"
    },
    heightPaper:{
        minHeight:"100%",
        height:"100%"
    },
    heightScrolledTableTop:{
        maxHeight: "610px",
    },
    heightScrolledTableBottom:{
        maxHeight: "500px",
    }
}), {index: 1});